import React from 'react';
import { isNumber } from 'lodash/fp';
import { Box } from '@material-ui/core';
import styled from 'styled-components';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { Typography, TypographyProps } from '../../../../ui-kit';
import { Bill } from './types';

type BillAmountProps = Pick<Bill, 'total' | 'dicountedTotalValue' | 'roundedPrice'>;

const LineThroughTypography = styled((props: TypographyProps) => <Typography {...props} />)`
    text-decoration: line-through;
`;

export const BillAmount: React.FC<BillAmountProps> = ({ total, dicountedTotalValue, roundedPrice }) => {
    const { priceService } = usePriceService();
    if (isNumber(dicountedTotalValue) && dicountedTotalValue !== total) {
        const discountedAmount = isNumber(roundedPrice) ? roundedPrice : dicountedTotalValue;
        return (
            <Box display='flex'>
                <LineThroughTypography variant='body2'>{priceService.toLocaleString(total)}</LineThroughTypography>
                <Box ml={0.5} />
                <Typography variant='body2'>{priceService.toLocaleString(discountedAmount)}</Typography>
            </Box>
        );
    }

    if (roundedPrice) {
        return <Typography variant='body2'>{priceService.toLocaleString(roundedPrice)}</Typography>;
    }
    return <Typography variant='body2'>{priceService.toLocaleString(total)}</Typography>;
};
